export default {
    methods: {
        $name(){
            let name = this.$store.state.user.username;
            return name;
        }
    },
}